
import { defineComponent } from "vue";
import { store } from "@/store";

export default defineComponent({
  components: {},
  props: {
    formId: {
      type: String,
      required: true,
    },
  },
  emits: ["reload"],
  data() {
    return {
      submitted: false,
      loading: false,
      name: "",
    };
  },
  computed: {
    form: function () {
      return store.getters["forms/getForms"].find((f: any) => f.formId === this.formId)
    },
  },
  watch: {
    form: function () {
      this.name = this.form?.name;
    }
  },
  mounted() {

    this.name = "";
  },
  methods: {
    submit: async function () {
      this.submitted = true;
      
        const res = await store.dispatch("forms/rename", {name: this.name, formId: this.formId});

      this.submitted = false;
      const el = this.$refs["closeBtn"] as any;
      el.click();
      this.$emit("reload");
    },
  },
});
